import React from "react";

// Discovery scan frequency as 15-minute-aligned presets. The server stores minutes
// (AiAssetConfigs.ScanFrequencyMinutes) and clamps to [15, 10080] snapped to 15, so every
// preset here round-trips unchanged.
export const SCAN_FREQUENCY_PRESETS = [
  { minutes: 15, label: "15 min" },
  { minutes: 30, label: "30 min" },
  { minutes: 45, label: "45 min" },
  { minutes: 60, label: "1 hour" },
  { minutes: 120, label: "2 hours" },
  { minutes: 240, label: "4 hours" },
  { minutes: 360, label: "6 hours" },
  { minutes: 720, label: "12 hours" },
  { minutes: 1440, label: "24 hours" },
  { minutes: 2880, label: "2 days" },
  { minutes: 10080, label: "7 days" },
];

export const SUB_HOURLY_WARNING =
  "Sub-hourly scans poll every connected provider each cycle; provider rate limits may apply.";

export default function AiScanFrequencySelect({ valueMinutes, onChange, disabled }) {
  const value = Number.isFinite(valueMinutes) ? valueMinutes : 1440;
  // A stored value outside the preset list (e.g. 90 after a backfill from 1.5 h) is shown as
  // its own option so nothing is silently changed on the next save.
  const options = SCAN_FREQUENCY_PRESETS.some((p) => p.minutes === value)
    ? SCAN_FREQUENCY_PRESETS
    : [...SCAN_FREQUENCY_PRESETS, { minutes: value, label: `${value} min` }].sort((a, b) => a.minutes - b.minutes);

  return (
    <div>
      <select
        aria-label="Scan frequency"
        value={value}
        disabled={disabled}
        onChange={(e) => onChange(parseInt(e.target.value, 10))}
        className="border border-border rounded-md px-2 py-1 text-sm bg-theme-secondary text-content-primary"
      >
        {options.map((o) => (
          <option key={o.minutes} value={o.minutes}>{o.label}</option>
        ))}
      </select>
      {value < 60 && (
        <p className="text-xs text-amber-600 dark:text-amber-400 mt-1">{SUB_HOURLY_WARNING}</p>
      )}
    </div>
  );
}
